'use client'

import React from 'react'
// import { Link } from 'react-router-dom'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import {
  setIsOpenInq,
  setProjectsFullListDetail
} from '../store/features/projectSlice'
// import Header_inquiry from "./forms/Header_inquiry";

export default function Header({
  adminDetail,
  propertylist,
  // completedPropertylist,
  // pageList,
  socialList
  // contactDetailData,
  // countryList
  // isOpenInq,
  // setIsOpenInq,
  // setProjects_full_list_detail,
  // projects_full_list_detail
}) {
  const pathName = usePathname()

  const dispatch = useDispatch()
  const isOpenInq = useSelector((state) => state.project.isOpenInq)
  const projects_full_list_detail = useSelector(
    (state) => state.project.projects_full_list_detail
  )

  const [isMounted, setIsMounted] = useState(false)
  const [isMobileScreen, setMobileScreen] = useState(false)
  const [categoryList, setCategoryList] = useState([])
  const [megaMenuCategory, setMegaMenuCategory] = useState('')
  const [megaMenuActive, setMegaMenuToggle] = useState(false)
  const [menuToggle, setMenuToggle] = useState(false)
  // const [isOpenInq, setIsOpenInq] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null)

  const handleClick = (bool) => {
    // console.log(pathName)
    if (bool && (pathName == '/' || pathName == '/plotted-development')) {
      dispatch(setProjectsFullListDetail([]))
    }
    dispatch(setIsOpenInq(bool))
    // console.log(projects_full_list_detail)
  }

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null) // Just close if already open
    } else {
      setActiveIndex(null) // Close all first
      setTimeout(() => {
        setActiveIndex(index) // Open new after delay (match transition time)
      }, 200) // 400ms should match your transition duration
    }
  }

  useEffect(() => {
    if (typeof window != undefined) {
      document.addEventListener('keydown', (e) => {
        if (e.code?.toLowerCase() == 'escape') {
          setMenuToggle(false)
          setMegaMenuToggle(false)
          setMegaMenuCategory('')
          handleClick(false)
        }
      })
    }
  }, [])

  useEffect(() => {
    if (window.innerWidth < 767) {
      setMobileScreen(true)
    }

    if (Array.isArray(propertylist)) {
      getCategory()
    }

    setIsMounted(true)
  }, [propertylist])

  useEffect(() => {
    if (isOpenInq) {
      document.body.style.overflow = 'hidden'
    } else if (menuToggle) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isOpenInq, menuToggle])

  async function getCategory() {
    try {
      const categorySet = new Set()
      const categoryArray = []

      propertylist.forEach((value) => {
        if (!categorySet.has(value.category)) {
          categoryArray.push({ category: value.category })
          categorySet.add(value.category)
        }
      })

      categoryArray.push({ category: 'Leasing' })
      //   console.log(categoryArray);

      setCategoryList(categoryArray)
    } catch (error) {
      console.error('Error fetching property details:', error)
    }
  }

  const megaMenuClick = (category) => {
    if (megaMenuCategory == category) {
      setMegaMenuCategory('')
      setMegaMenuToggle(false)
    } else {
      setMegaMenuCategory(category)
      setMegaMenuToggle(true)
    }
  }
  const megaMenuClickClose = () => {
    setMegaMenuCategory('')
    setMegaMenuToggle(false)
    // handleClick(false);
  }

  const [showNavbar, setShowNavbar] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      setMegaMenuToggle(false)
      setMegaMenuCategory('')
      if (currentScrollY > lastScrollY) {
        setShowNavbar(false) // scrolling down
      } else {
        setShowNavbar(true) // scrolling up
      }

      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  // if (!categoryList || categoryList.length === 0) return null;

  return (
    <>
      <div className={`header-wrapper ${showNavbar ? '' : 'webmenu_hidden'}`}>
        <div className="header-flex">
          {/* <div className="header-logo"> */}
          <div className="reecosys-brand-logo">
            <Link
              href="/"
              onClick={() => {
                setMenuToggle(false)
                setMegaMenuToggle(false)
              }}
              title="Venus Group"
              aria-label="Venus Group"
            >
              {isMounted && adminDetail?.logo && (
                <img src={adminDetail.logo} alt={adminDetail.name || 'Logo'} />
              )}
            </Link>
          </div>

          <div className="header-links-ul" style={{ minHeight: '1.5rem' }}>
            <ul className="link-font-size g2">
              {!menuToggle &&
                !isOpenInq &&
                categoryList.map((categoryData, index) => (
                  <li
                    key={index}
                    className="hide-tab-mobile"
                    onClick={(e) => {
                      e.stopPropagation()
                      setMenuToggle(false)
                      megaMenuClick(categoryData.category)
                    }}
                  >
                    <a
                      href="javascript:void(0)"
                      className={
                        megaMenuCategory === categoryData.category
                          ? 'active'
                          : ''
                      }
                    >
                      <p
                        className={`capitalize ${
                          megaMenuCategory === categoryData.category
                            ? 'secondary-color'
                            : ''
                        }`}
                      >
                        {categoryData.category === 'Leasing'
                          ? 'Leasing'
                          : categoryData.category}
                      </p>
                      {/* <span className="material-symbols-outlined">
                    keyboard_arrow_down
                  </span> */}
                      <div
                        className={`header-navigation-links-arrow ${
                          megaMenuActive &&
                          megaMenuCategory === categoryData.category
                            ? 'active'
                            : ''
                        }`}
                      >
                        <img src="/images/icon/down_arrow.png" alt="down" />
                      </div>
                    </a>
                  </li>
                ))}
              {!isMobileScreen && !menuToggle && !isOpenInq && (
                <li className="head-btn">
                  {/* ng-if="!isMobilescreen &amp;&amp; !mobile_header_f" */}

                  <div className="wfc inquire-now-header-btn">
                    <div className="filled-div-button button-div">
                      <button
                        onClick={() => {
                          // inquire_popup_web_toggle();
                          handleClick(true)
                          megaMenuClickClose()
                        }}
                        className="button-style red-btn"
                      >
                        {projects_full_list_detail &&
                        projects_full_list_detail.project_id == '621' ? (
                          <p className="capitalize lora-regular">Enquire Now</p>
                        ) : (
                          <p className="capitalize lora-regular">Inquire Now</p>
                        )}
                      </button>
                    </div>
                  </div>
                </li>
              )}
              {/* <li className="visible-tab-mobile">
              <div
                onClick={(e) => {
                  setMenuToggle(false);
                }}
              >
                <img src="/images/icon/call.svg" alt="Call icon" />
              </div>
            </li> */}
              <li>
                <div
                  className={`menubar ${menuToggle ? 'active' : ''}`}
                  onClick={() => {
                    setMenuToggle(!menuToggle)
                    megaMenuClickClose()
                  }}
                >
                  <div className="bar bar-top"></div>
                  <div className="bar bar-middle"></div>
                  <div className="bar bar-bottom"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {megaMenuActive && propertylist.length > 0 && (
          <div
            className={`menu-dropdown-web ${
              megaMenuActive ? 'show_dropdown' : ''
            }`}
            id="megamenu-wrapper"
          >
            <div className="">
              <ul>
                <li className="section-title">
                  <h2>
                    {megaMenuCategory} <br />
                    Projects
                  </h2>
                </li>
                {megaMenuCategory != 'Leasing' &&
                  propertylist
                    .filter((project) => project.project_id != '621')
                    .map(
                      (data, index) =>
                        data.category === megaMenuCategory && (
                          <li
                            key={index}
                            className={`links-flex-column megamenuLink ${
                              data.category === megaMenuCategory
                                ? 'showProject'
                                : ''
                            }`}
                          >
                            <Link
                              key={data.project_title}
                              href={`/${data.slug}`}
                              className="inner-flex "
                              onClick={() => {
                                megaMenuClickClose()
                              }}
                            >
                              <div className="dropdown_project_list relative">
                                {data.banner_data.image_web_type == 'image' && (
                                  <div className="header_project_thum border-radius-web relative">
                                    <img
                                      loading="lazy"
                                      className=""
                                      // onLoad={(e) =>
                                      //   (e.currentTarget.style.opacity = '1')
                                      // }
                                      src={`${data.banner_data.image_web_full}&h=450&w=720`}
                                      style={{ aspectRatio: '16/10' }}
                                      alt="reecosys"
                                    />
                                  </div>
                                )}

                                {data.banner_data.image_web_type == 'video' && (
                                  <div className="header_project_thum border-radius-web relative">
                                    <video
                                      autoplay
                                      muted
                                      loop
                                      playsinline
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'block',
                                        objectFit: 'cover'
                                      }}
                                    >
                                      <source
                                        src={data.banner_data.image_web_full}
                                        type="video/mp4"
                                      />
                                    </video>
                                  </div>
                                )}
                                <div className="section-content projectListTag statusTag">
                                  <p className="uppercase white-color">
                                    {data.status == 'under construction'
                                      ? 'Ongoing'
                                      : data.status}
                                  </p>
                                </div>
                              </div>

                              <div className="dropdown_project_content">
                                {/* <div className="inner-flex"> */}
                                {/* <div className="section-paragraph flex-row j-c-sb alc"> */}
                                {data.project_title && (
                                  <div className="dropdown_project_title">
                                    <h4 className="">{data.project_title}</h4>
                                  </div>
                                )}
                                {/* <div className="project-arrow-icon common-icon">
                                      <img
                                        src="/images/icon/right_arrow_line.svg"
                                        alt={data.project_title}
                                      />
                                    </div> */}
                                {/* </div> */}
                                <div className="dropdown_project_info_list">
                                  {data.size_price && (
                                    <div className={`dropdown_project_info`}>
                                      <div className="dropdown_project_img">
                                        <img
                                          src="/images/icon/building.png"
                                          alt="Building Icon"
                                        />
                                      </div>
                                      <div className="capitalize mt4">
                                        <p>{data.size_price}</p>
                                      </div>
                                    </div>
                                  )}

                                  {data.location && (
                                    <div className={`dropdown_project_info`}>
                                      <div className="dropdown_project_img">
                                        <img
                                          src="/images/icon/location.png"
                                          alt="Location Icon"
                                        />
                                      </div>
                                      <div className="capitalize mt2">
                                        <p>{data.location}</p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                {/* </div> */}
                              </div>
                            </Link>
                          </li>
                        )
                    )}
                {megaMenuCategory == 'Leasing' &&
                  propertylist
                    .filter((project) => project.project_id == '621')
                    .map((data, index) => (
                      <li
                        key={index}
                        className={`showProject links-flex-column megamenuLink`}
                      >
                        <Link
                          key={data.project_title}
                          href={`/${data.slug}`}
                          className="inner-flex "
                          onClick={() => {
                            megaMenuClickClose()
                          }}
                        >
                          <div className="dropdown_project_list relative">
                            {data.banner_data.image_web_type == 'image' && (
                              <div className="header_project_thum border-radius-web relative">
                                <img
                                  loading="lazy"
                                  src={`${data.banner_data.image_web_full}&h=450&w=720`}
                                  // style={{ aspectRatio: "32/25" }}
                                  className=""
                                  style={{ aspectRatio: '16/10' }}
                                  alt="reecosys"
                                />
                              </div>
                            )}

                            {data.banner_data.image_web_type == 'video' && (
                              <div className="header_project_thum border-radius-web relative">
                                <video
                                  autoplay
                                  muted
                                  loop
                                  playsinline
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'block',
                                    objectFit: 'cover'
                                  }}
                                >
                                  <source
                                    src={data.banner_data.image_web_full}
                                    type="video/mp4"
                                  />
                                </video>
                              </div>
                            )}
                            <div className="section-content projectListTag statusTag">
                              <p className="uppercase white-color">
                                {data.status == 'under construction'
                                  ? 'Ongoing'
                                  : data.status}
                              </p>
                            </div>
                          </div>

                          <div className="dropdown_project_content">
                            {/* <div className="inner-flex"> */}
                            {/* <div className="section-paragraph flex-row j-c-sb alc"> */}
                            {data.project_title && (
                              <div className="dropdown_project_title">
                                <h4 className="">{data.project_title}</h4>
                              </div>
                            )}
                            {/* <div className="project-arrow-icon common-icon">
                                      <img
                                        src="/images/icon/right_arrow_line.svg"
                                        alt={data.project_title}
                                      />
                                    </div> */}
                            {/* </div> */}
                            <div className="dropdown_project_info_list">
                              {data.size_price && (
                                <div className={`dropdown_project_info`}>
                                  <div className="dropdown_project_img">
                                    <img
                                      src="/images/icon/building.png"
                                      alt="Building Icon"
                                    />
                                  </div>
                                  <div className="capitalize mt4">
                                    <p>{data.size_price}</p>
                                  </div>
                                </div>
                              )}

                              {data.location && (
                                <div className={`dropdown_project_info`}>
                                  <div className="dropdown_project_img">
                                    <img
                                      src="/images/icon/location.png"
                                      alt="Location Icon"
                                    />
                                  </div>
                                  <div className="capitalize mt2">
                                    <p>{data.location}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* </div> */}
                          </div>
                        </Link>
                      </li>
                    ))}
                {/* {megaMenuCategory == "Leasing" &&
                  propertylist
                    .filter((project) => project.project_id == "621")
                    .map((data, index) => (
                      <li
                        key={index}
                        className="showProject links-flex-column megamenuLink"
                      >
                        <div
                          className={`megamenuItem relative inner-flex 
                  ${pathName === data.slug ? "active" : ""}`}
                        >
                          <Link
                            key={data.project_title}
                            href={data.slug}
                            className="inner-flex "
                            onClick={() => {
                              megaMenuClickClose();
                            }}
                          >
                            <div className="relative">
                              {data.banner_data.image_web_type == "image" && (
                                <div className="header_project_thum border-radius-web relative">
                                  <img
                                    loading="lazy"
                                    src={`${data.banner_data.image_web_full}&h=450&w=720`}
                                    // style={{ aspectRatio: "32/25" }}
                                    alt="reecosys"
                                  />
                                </div>
                              )}

                              {data.banner_data.image_web_type == "video" && (
                                <div className="header_project_thum border-radius-web relative">
                                  <video autoplay muted loop playsinline>
                                    <source
                                      src={data.banner_data.image_web_full}
                                      type="video/mp4"
                                    />
                                  </video>
                                </div>
                              )}
                            </div>

                            <div className="dropdown_project_content">
                              <div className="inner-flex">
                                <div className="section-paragraph flex-row j-c-sb alc">
                                  <h2 className="text-uppercase charter_regular">
                                    {data.project_title}
                                  </h2>
                                  <div className="project-arrow-icon common-icon">
                                    <img
                                      src="/images/icon/right_arrow_line.svg"
                                      alt={data.project_title}
                                    />
                                  </div>
                                </div>
                                <div className="flex-row flex-wrapgap1 alc inner-flex-smallest">
                                  {data.size_price && (
                                    <div
                                      className={`project-information-div flex-row alc inner-flex-smallest ${
                                        isMobileScreen ? "w100" : ""
                                      } `}
                                    >
                                      <div className="building-icon common-icon">
                                        <img
                                          src="/images/icon/building.svg"
                                          alt="Building Icon"
                                        />
                                      </div>
                                      <div className="section-textpara banner-detail-row-grid-text">
                                        <p className="capitalize ellipsis-1">
                                          {data.size_price}
                                        </p>
                                      </div>
                                    </div>
                                  )}

                                  {data.location && (
                                    <div
                                      className={`project-information-div flex-row alc inner-flex-smallest ${
                                        isMobileScreen ? "w100" : ""
                                      } `}
                                    >
                                      <div className="building-icon common-icon">
                                        <img
                                          src="/images/icon/location.svg"
                                          alt="Location Icon"
                                        />
                                      </div>
                                      <div className="section-textpara">
                                        <p className="capitalize ellipsis-1">
                                          {data.location}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </li>
                    ))} */}
              </ul>
            </div>
          </div>
        )}

        {/* {megaMenuActive && <div className={`click-overlay active`}
    onClick={()=>megaMenuClickClose()}></div>} */}

        <div
          className={`click-overlay ${
            megaMenuActive || menuToggle || isOpenInq ? 'active' : ''
          } `}
          onClick={() => {
            megaMenuClickClose()
            setMenuToggle(false)
            handleClick(false)
          }}
        ></div>

        <div
          className={`mobile_menu_wrapper inner-flex inner-flex-medium j-c-sb  ${
            menuToggle ? 'mobileMenuActive' : ''
          } `}
        >
          <div className="header-navigation-links">
            <ul className="">
              <li>
                <div>
                  <Link
                    href="/"
                    className={`capitalize section-paragraph ${
                      pathName == '/' ? 'active_page' : ''
                    } `}
                    onClick={() => {
                      setMenuToggle(false)
                    }}
                    title="Home"
                  >
                    <p>Home</p>
                  </Link>
                </div>
              </li>
              <li className={`accordion-block`} id="accordion">
                <div
                  onClick={() => toggleAccordion('about')}
                  className={`flex-row j-c-sb header_accordion accordion_click ${
                    activeIndex == 'about' ? 'active' : ''
                  }`}
                >
                  <div className="section-paragraph">
                    <p className="capitalize semibold-fonts">About</p>
                  </div>
                  <div>
                    <img
                      src="/images/icon/down-arrow.png"
                      alt=""
                      className="manu-accordian-downarrow"
                    />
                    <img
                      src="/images/icon/up-arrow.png"
                      alt=""
                      className="manu-accordian-uparrow"
                    />
                  </div>
                </div>
                <div
                  className={`aboutContentAccordion content_accordian_header ${
                    activeIndex == 'about' ? 'content_accordianActive' : ''
                  }`}
                  style={{
                    padding: 0,
                    paddingTop: activeIndex == 'about' ? '1rem' : 0
                  }}
                >
                  <ul>
                    <li
                      className={`pt0 capitalize section-paragraph ${
                        pathName == '/about-us' ? 'active_page' : ''
                      } `}
                      onClick={() => {
                        setMenuToggle()
                        toggleAccordion(null)
                        // console.log(pathName);
                      }}
                    >
                      <Link href="/about-us" className="section-paragraph  ">
                        <p className="dropdown_txt capitalize">About Us</p>
                      </Link>
                    </li>
                    <li
                      className={`capitalize section-paragraph ${
                        pathName == '/awards' ? 'active_page' : ''
                      } `}
                      onClick={() => {
                        setMenuToggle()
                        toggleAccordion(null)
                      }}
                    >
                      <Link href="/awards" className="section-paragraph ">
                        <p className="dropdown_txt capitalize">Awards</p>
                      </Link>
                    </li>
                    <li
                      className={`capitalize section-paragraph ${
                        pathName == '/leadership' ? 'active_page' : ''
                      } `}
                      onClick={() => {
                        setMenuToggle()
                        toggleAccordion(null)
                      }}
                    >
                      <Link href="/leadership" className="section-paragraph ">
                        <p className="dropdown_txt capitalize">Leadership</p>
                      </Link>
                    </li>
                    <li
                      className={`capitalize section-paragraph ${
                        pathName == '/news' ? 'active_page' : ''
                      } `}
                      onClick={() => {
                        setMenuToggle()
                        toggleAccordion(null)
                      }}
                    >
                      <Link href="/news" className="section-paragraph ">
                        <p className="dropdown_txt capitalize">News & Events</p>
                      </Link>
                    </li>
                    <li
                      className={`no-border  capitalize section-paragraph ${
                        pathName == '/media' ? 'active_page' : ''
                      } `}
                      onClick={() => {
                        setMenuToggle()
                        toggleAccordion(null)
                      }}
                    >
                      <Link href="/media" className="section-paragraph ">
                        <p className="dropdown_txt capitalize">Media</p>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              {categoryList.map((category_data, index) => (
                <li key={index} className=" accordion-block" id="accordion">
                  <div
                    onClick={() => toggleAccordion(index)}
                    className={`flex-row j-c-sb header_accordion accordion_click  ${
                      activeIndex === index ? 'active' : ''
                    } `}
                  >
                    <div className="section-paragraph">
                      <p className="capitalize semibold-fonts">
                        {category_data.category == 'Leasing'
                          ? 'Leasing'
                          : category_data.category}
                      </p>
                    </div>
                    <div>
                      <img
                        src="/images/icon/down-arrow.png"
                        alt=""
                        className="manu-accordian-downarrow"
                      />
                      <img
                        src="/images/icon/up-arrow.png"
                        alt=""
                        className="manu-accordian-uparrow"
                      />
                    </div>
                  </div>
                  <div
                    // className={`content_accordian_header ${
                    className={`content_accordian_header ${
                      activeIndex === index ? 'content_accordianActive' : ''
                    }`}
                  >
                    <div>
                      <div className="inner-flex projectList_li inner-flex-zero">
                        {/* <div className="inner-flex projectList_li inner-flex-zero"> */}
                        {propertylist != null &&
                          // megaMenuCategory != "Leasing" &&
                          propertylist.length > 0 &&
                          propertylist
                            //   .filter((data) => data.project_id != "621")
                            .map((data, index2) => {
                              if (
                                data.category == category_data.category &&
                                data.project_id != '621'
                              ) {
                                return (
                                  <div
                                    className={`${index2 == 0 ? '' : 'pt0'}`}
                                    key={index2}
                                  >
                                    <Link
                                      href={`/${data.slug}`}
                                      className="header-hover"
                                      onClick={() => {
                                        setMenuToggle(false)
                                        toggleAccordion(null)
                                      }}
                                    >
                                      <div className="flex-row flex-gap-small">
                                        {data.banner_data.image_web_full && (
                                          <div
                                            className="flex-30 border-radius-web"
                                            title={data.project_title}
                                          >
                                            {data.banner_data.image_web_type ==
                                              'image' && (
                                              <img
                                                loading="lazy"
                                                src={`${data.banner_data.image_web_full}&h=300&w=300`}
                                                // style={{ aspectRatio: "32/25" }}
                                                alt="reecosys"
                                              />
                                            )}
                                            {/* {data.banner_data.image_web_type ==
                                              "video" && (
                                              <video
                                                autoplay
                                                muted
                                                loop
                                                playsinline
                                                id="myVideo"
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  display: "block",
                                                  objectFit: "cover",
                                                }}
                                              >
                                                <source
                                                  src={
                                                    data.banner_data
                                                      .image_web_full
                                                  }
                                                  type="video/mp4"
                                                />
                                              </video>
                                            )} */}
                                          </div>
                                        )}

                                        <div className="flex-70 inner-flex">
                                          <div className="section-paragraph">
                                            {data.project_title && (
                                              <p className="header-title capitalize">
                                                {data.project_title}
                                              </p>
                                            )}
                                          </div>
                                          <div className="inner-flex inner-flex-smallest">
                                            {data.location && (
                                              <div className="flex-row alc">
                                                <div className="iconimg">
                                                  <img
                                                    src="/images/icon/location.png"
                                                    alt=""
                                                  />
                                                </div>
                                                <div className="section-content">
                                                  <span className="ellipsis-1">
                                                    {data.location}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                            {data.size_price && (
                                              <div className="flex-row alc">
                                                <div className="iconimg">
                                                  <img
                                                    src="/images/icon/building.png"
                                                    alt=""
                                                  />
                                                </div>
                                                <div className=" section-content">
                                                  <span className="ellipsis-1">
                                                    {data.size_price}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                            {data.construction && (
                                              <div className="flex-row alc">
                                                <div className="progress-statuss">
                                                  {/* ng-if="data.construction.progress_percent > 0" */}
                                                  {data.construction
                                                    .progress_percent > 0 && (
                                                    <div
                                                      className="progress"
                                                      data-percentage={
                                                        data.construction
                                                          .progress_percent
                                                      }
                                                    >
                                                      <span className="progress-left">
                                                        <span className="progress-bar"></span>
                                                      </span>
                                                      <span className="progress-right">
                                                        <span className="progress-bar"></span>
                                                      </span>
                                                      <div className="progress-value value_get">
                                                        <p>
                                                          {
                                                            data.construction
                                                              .progress_percent
                                                          }
                                                        </p>
                                                      </div>
                                                    </div>
                                                  )}
                                                  {data.construction
                                                    .progress_percent == 0 && (
                                                    <div className="iconimg">
                                                      <img
                                                        src="/images/icon/construction.png"
                                                        alt=""
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                                {data.status && (
                                                  <div className="section-content capitalize">
                                                    <span>{data.status}</span>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                )
                              }
                            })}
                        {propertylist != null &&
                          // megaMenuCategory != "Leasing" &&
                          propertylist.length > 0 &&
                          propertylist
                            //   .filter((data) => data.project_id != "621")
                            .map((data, index2) => {
                              if (
                                category_data.category == 'Leasing' &&
                                data.project_id == '621'
                              ) {
                                return (
                                  <div
                                    className={`${index2 == 0 ? '' : 'pt0'}`}
                                    key={index2}
                                  >
                                    <Link
                                      href={`/${data.slug}`}
                                      className="header-hover"
                                      onClick={() => {
                                        setMenuToggle(false)
                                        toggleAccordion(null)
                                      }}
                                    >
                                      <div className="flex-row flex-gap-small">
                                        {data.banner_data.image_web_full && (
                                          <div
                                            className="flex-30 border-radius-web"
                                            title={data.project_title}
                                          >
                                            {data.banner_data.image_web_type ==
                                              'image' && (
                                              <img
                                                loading="lazy"
                                                src={`${data.banner_data.image_web_full}&h=300&w=300`}
                                                // style={{ aspectRatio: "32/25" }}
                                                alt="reecosys"
                                              />
                                            )}
                                            {/* {data.banner_data.image_web_type ==
                                              "video" && (
                                              <video
                                                autoplay
                                                muted
                                                loop
                                                playsinline
                                                id="myVideo"
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  display: "block",
                                                  objectFit: "cover",
                                                }}
                                              >
                                                <source
                                                  src={
                                                    data.banner_data
                                                      .image_web_full
                                                  }
                                                  type="video/mp4"
                                                />
                                              </video>
                                            )} */}
                                          </div>
                                        )}

                                        <div className="flex-70 inner-flex">
                                          <div className="section-paragraph">
                                            {data.project_title && (
                                              <p className="header-title capitalize">
                                                {data.project_title}
                                              </p>
                                            )}
                                          </div>
                                          <div className="inner-flex inner-flex-smallest">
                                            {data.location && (
                                              <div className="flex-row alc">
                                                <div className="iconimg">
                                                  <img
                                                    src="/images/icon/location.png"
                                                    alt=""
                                                  />
                                                </div>
                                                <div className="section-content">
                                                  <span className="ellipsis-1">
                                                    {data.location}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                            {data.size_price && (
                                              <div className="flex-row alc">
                                                <div className="iconimg">
                                                  <img
                                                    src="/images/icon/building.png"
                                                    alt=""
                                                  />
                                                </div>
                                                <div className=" section-content">
                                                  <span className="ellipsis-1">
                                                    {data.size_price}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                            {data.construction && (
                                              <div className="flex-row alc">
                                                <div className="progress-statuss">
                                                  {/* ng-if="data.construction.progress_percent > 0" */}
                                                  {data.construction
                                                    .progress_percent > 0 && (
                                                    <div
                                                      className="progress"
                                                      data-percentage={
                                                        data.construction
                                                          .progress_percent
                                                      }
                                                    >
                                                      <span className="progress-left">
                                                        <span className="progress-bar"></span>
                                                      </span>
                                                      <span className="progress-right">
                                                        <span className="progress-bar"></span>
                                                      </span>
                                                      <div className="progress-value value_get">
                                                        <p>
                                                          {
                                                            data.construction
                                                              .progress_percent
                                                          }
                                                        </p>
                                                      </div>
                                                    </div>
                                                  )}
                                                  {data.construction
                                                    .progress_percent == 0 && (
                                                    <div className="iconimg">
                                                      <img
                                                        src="/images/icon/construction.png"
                                                        alt=""
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                                {data.status && (
                                                  <div className="section-content capitalize">
                                                    <span>{data.status}</span>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                )
                              }
                            })}
                        {/* {propertylist != null &&
                          // megaMenuCategory != "Leasing" &&
                          propertylist.length > 0 &&
                          propertylist
                            //   .filter((data) => data.project_id != "621")
                            .map((data, index2) => {
                              if (
                                category_data.category == "Leasing" &&
                                data.project_id == "621"
                              ) {
                                return (
                                  <div key={index2}>
                                    <Link
                                      href={data.slug}
                                      className="header-hover"
                                      onClick={() => {
                                        setMenuToggle(false);
                                      }}
                                    >
                                      <div className="inner-flex inner-flex-smallest">
                                        <div className="w100 relative">
                                          <img
                                            loading="lazy"
                                            src={`${data.banner_data.image_web_full}&h=450&w=720`}
                                            style={{ aspectRatio: "32/25" }}
                                            alt="reecosys"
                                          />
                                        </div>
                                        <div className=" w100 inner-flex inner-flex-smallest">
                                          <div className="section-paragraph">
                                            <p className=" header-title capitalize ">
                                              {data.project_title}
                                            </p>
                                          </div>
                                          <div className="flex-row flex-wrapgap1 flex-row-mobile inner-flex-smallest">
                                            <div className="flex-row alc">
                                              <div className="iconimg">
                                                <img
                                                  src="/images/icon/location.svg"
                                                  alt=""
                                                />
                                              </div>
                                              <div className=" section-content">
                                                <span className="ellipsis-1">
                                                  {data.location}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="flex-row alc">
                                              <div className="iconimg">
                                                <img
                                                  src="/images/icon/building.svg"
                                                  alt=""
                                                />
                                              </div>
                                              <div className=" section-content">
                                                <span className="ellipsis-1">
                                                  {data.size_price}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                );
                              }
                            })} */}

                        {/* {completedPropertylist != null &&
                            completedPropertylist.length > 0 &&
                            completedPropertylist.map((data, index3) => {
                              if (
                                data.category == category_data.category &&
                                data.project_id == "764"
                              ) {
                                return (
                                  <div key={index3}>
                                    <Link
                                      href={data.slug}
                                      className="header-hover"
                                      onClick={() => {
                                        setMenuToggle(false);
                                      }}
                                    >
                                      <div className="inner-flex inner-flex-smallest">
                                        <div className="w100 relative">
                                          <img
                                            loading="lazy"
                                            src={`/images/banner/${data.banner_data.image_web}`}
                                            style={{ aspectRatio: "32/25" }}
                                            alt="reecosys"
                                          />
                                        </div>
                                        <div className=" w100 inner-flex inner-flex-smallest">
                                          <div className="section-paragraph">
                                            <p className=" header-title capitalize ">
                                              {data.project_title}
                                            </p>
                                          </div>
                                          <div className="flex-row flex-wrapgap1 flex-row-mobile inner-flex-smallest">
                                            <div className="flex-row alc">
                                              <div className="iconimg">
                                                <img
                                                  src="/images/icon/location.svg"
                                                  alt=""
                                                />
                                              </div>
                                              <div className=" section-content">
                                                <span className="ellipsis-1">
                                                  {data.location}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="flex-row alc">
                                              <div className="iconimg">
                                                <img
                                                  src="/images/icon/building.svg"
                                                  alt=""
                                                />
                                              </div>
                                              <div className=" section-content">
                                                <span className="ellipsis-1">
                                                  {data.size_price}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                );
                              }
                            })} */}
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </li>
              ))}

              <li>
                <div>
                  <Link
                    href="/completed-projects"
                    className={`capitalize section-paragraph ${
                      pathName == '/completed-projects' ? 'active_page' : ''
                    } `}
                    onClick={() => {
                      setMenuToggle(false)
                      toggleAccordion(null)
                    }}
                    title="Completed Projects"
                  >
                    <p>Completed Projects</p>
                  </Link>
                </div>
              </li>

              <li>
                <div>
                  <Link
                    href="/vendor"
                    className={`capitalize section-paragraph ${
                      pathName == '/vendor' ? 'active_page' : ''
                    } `}
                    onClick={() => {
                      setMenuToggle(false)
                      toggleAccordion(null)
                    }}
                    title="Completed Projects"
                  >
                    <p>Vendor</p>
                  </Link>
                </div>
              </li>
              <li>
                <div>
                  <Link
                    href="/redevelopment"
                    className={`capitalize section-paragraph ${
                      pathName == '/redevelopment' ? 'active_page' : ''
                    } `}
                    onClick={() => {
                      setMenuToggle(false)
                      toggleAccordion(null)
                    }}
                    title="Completed Projects"
                  >
                    <p>Redevelopment</p>
                  </Link>
                </div>
              </li>
              <li>
                <div>
                  <Link
                    href="/career"
                    className={`capitalize section-paragraph ${
                      pathName == '/career' ? 'active_page' : ''
                    } `}
                    onClick={() => {
                      setMenuToggle(false)
                      toggleAccordion(null)
                    }}
                    title="Completed Projects"
                  >
                    <p>Career</p>
                  </Link>
                </div>
              </li>
              <li>
                <div>
                  <Link
                    href="/contact-us"
                    className={`capitalize section-paragraph ${
                      pathName == '/contact-us' ? 'active_page' : ''
                    } `}
                    onClick={() => {
                      setMenuToggle(false)
                      toggleAccordion(null)
                    }}
                    title="Completed Projects"
                  >
                    <p>Contact</p>
                  </Link>
                </div>
              </li>
              {/* {pageList != null &&
              pageList.length > 0 &&
              pageList.map((data, index) => {
                if (data.page_type == "" && data.is_profile_page == 0) {
                  return (
                    <li key={index}>
                      <div>
                        <Link
                          href={data.slug}
                          className={`capitalize section-paragraph ${
                            pathName == data.slug ? "active_page" : ""
                          } `}
                          onClick={() => {
                            setMenuToggle(false);
                          }}
                          title={data.page_name}
                          target={data.slug_target}
                        >
                          <p>{data.page_name}</p>
                        </Link>
                      </div>
                    </li>
                  );
                }
              })} */}
              {socialList != null && socialList.length > 0 && (
                <li className="flex-row alc no-border socialMediaFlex">
                  {socialList.map((social, index) => (
                    <div className="navigation-mobile-icon" key={index}>
                      {social.name == 'facebook' && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/images/social/facebook.png"
                            alt="facebook"
                          />
                        </a>
                      )}
                      {social.name == 'instagram' && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/images/social/instagram.png"
                            alt="instagram"
                          />
                        </a>
                      )}
                      {social.name == 'twitter' && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="/images/social/twitter.png" alt="twitter" />
                        </a>
                      )}
                      {social.name == 'linkedin' && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="/images/social/indeed.png" alt="linkedin" />
                        </a>
                      )}
                      {social.name == 'youtube' && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="/images/social/youtube.png" alt="youtube" />
                        </a>
                      )}
                    </div>
                  ))}
                </li>
              )}
            </ul>
          </div>
          <div className="w100 inquire-now-header-btn">
            <div className="filled-div-button button-div">
              <button
                onClick={() => {
                  // inquire_popup_web_toggle();
                  handleClick(true)
                  setMenuToggle(false)
                  megaMenuClickClose()
                }}
                className="button-style red-btn"
              >
                {projects_full_list_detail &&
                projects_full_list_detail.project_id == '621' ? (
                  <p className="capitalize lora-regular">Enquire Now</p>
                ) : (
                  <p className="capitalize lora-regular">Inquire Now</p>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <Header_inquiry
        isOpenInq={isOpenInq}
        setIsOpenInq={setIsOpenInq}
        contactDetailData={contactDetailData}
        propertylist={propertylist}
        pageList={pageList}
        projects_full_list_detail={null}
        countryList={countryList}
      /> */}
      {/* <div className="quickEnquiryOverlay"
        ng-click="inquire_popup_web_toggle_close(); country_code_click_false(); mobile_header_close(); "
        ng-className="{'inqury_active': inquire_popup_web_toggleF || mobile_header_f }">
      </div> */}
    </>
  )
}
